// Field conversion mapping options for auto-populating form fields
// Currently ONLY used for creating new forms (or using the edit form)
// DO NOT USE on old existing forms that are not set up for these field names 2025.12
export const fieldConversionMappings = [
  { pdfFieldName: "Logo", convertTo: "transaction_brokerageLogoRef" },

  { pdfFieldName: "Date", convertTo: "transaction_currentDate" },
  { pdfFieldName: "Date Contract Date", convertTo: "transaction_contractDateTime" },
  { pdfFieldName: "Contract Date Text", convertTo: "transaction_contractDateText"},
  { pdfFieldName: "Date Closing Date", convertTo: "transaction_closingDateTime" },
  { pdfFieldName: "Closing Date Text", convertTo: "transaction_closingDateText"},

  { pdfFieldName: "Date Listing Contract Date", convertTo: "transaction_listingContractDateTime" },
  { pdfFieldName: "Listing Contract Date Text", convertTo: "transaction_listingContractDateText"},

  { pdfFieldName: "Seller", convertTo: "transaction_sellerLegalName" },
  { pdfFieldName: "Buyer", convertTo: "transaction_buyerLegalName" },

  { pdfFieldName: "Sellers Legal Name", convertTo: "transaction_sellerLegalName" },
  { pdfFieldName: "Buyers Legal Name", convertTo: "transaction_buyerLegalName" },
  { pdfFieldName: "Sellers Legal Name 2", convertTo: "transaction_sellerLegalName" },
  { pdfFieldName: "Buyers Legal Name 2", convertTo: "transaction_buyerLegalName" },

  { pdfFieldName: "Address Full", convertTo: "transaction_addressFull" },
  { pdfFieldName: "Address Full 2", convertTo: "transaction_addressFull" },
  { pdfFieldName: "Address Street", convertTo: "transaction_addressStreetAndUnit" },
  { pdfFieldName: "Address City State Zip", convertTo: "transaction_addressCityStateZip" },
  { pdfFieldName: "Address City", convertTo: "transaction_addressCity" },
  { pdfFieldName: "Address State", convertTo: "transaction_addressState" },
  { pdfFieldName: "Address Zip", convertTo: "transaction_addressZipcode" },
  { pdfFieldName: "Address Legal Description", convertTo: "transaction_addressLegal" },
  { pdfFieldName: "Address County", convertTo: "transaction_addressCounty" },

  { pdfFieldName: "Seller 1 First Name", convertTo: "seller_firstName" },
  { pdfFieldName: "Seller 1 Last Name", convertTo: "seller_lastName" },
  { pdfFieldName: "Seller 1 Name", convertTo: "seller_legalName" },
   { pdfFieldName: "Seller 1 First Name 2", convertTo: "seller_firstName" },
  { pdfFieldName: "Seller 1 Last Name 2", convertTo: "seller_lastName" },
  { pdfFieldName: "Seller 1 Name 2", convertTo: "seller_legalName" },
  { pdfFieldName: "Seller 1 Email", convertTo: "seller_email" },
  { pdfFieldName: "Seller 1 Phone", convertTo: "seller_phone" },
  { pdfFieldName: "Seller 1 Address Full", convertTo: "seller_addressFull" },

  { pdfFieldName: "Seller 2 First Name", convertTo: "seller2_firstName" },
  { pdfFieldName: "Seller 2 Last Name", convertTo: "seller2_lastName" },
  { pdfFieldName: "Seller 2 Name", convertTo: "seller2_legalName" },
  { pdfFieldName: "Seller 2 First Name 2", convertTo: "seller2_firstName" },
  { pdfFieldName: "Seller 2 Last Name 2", convertTo: "seller2_lastName" },
  { pdfFieldName: "Seller 2 Name 2", convertTo: "seller2_legalName" },
  { pdfFieldName: "Seller 2 Email", convertTo: "seller2_email" },
  { pdfFieldName: "Seller 2 Phone", convertTo: "seller2_phone" },

  { pdfFieldName: "Seller 3 First Name", convertTo: "seller3_firstName" },
  { pdfFieldName: "Seller 3 Last Name", convertTo: "seller3_lastName" },
  { pdfFieldName: "Seller 3 Name", convertTo: "seller3_legalName" },
  { pdfFieldName: "Seller 3 First Name 2", convertTo: "seller3_firstName" },
  { pdfFieldName: "Seller 3 Last Name 2", convertTo: "seller3_lastName" },
  { pdfFieldName: "Seller 3 Name 2", convertTo: "seller3_legalName" },
  { pdfFieldName: "Seller 3 Email", convertTo: "seller3_email" },
  { pdfFieldName: "Seller 3 Phone", convertTo: "seller3_phone" },

  { pdfFieldName: "Buyer 1 First Name", convertTo: "buyer_firstName" },
  { pdfFieldName: "Buyer 1 Last Name", convertTo: "buyer_lastName" },
  { pdfFieldName: "Buyer 1 Name", convertTo: "buyer_legalName" },
  { pdfFieldName: "Buyer 1 First Name 2", convertTo: "buyer_firstName" },
  { pdfFieldName: "Buyer 1 Last Name 2", convertTo: "buyer_lastName" },
  { pdfFieldName: "Buyer 1 Name 2", convertTo: "buyer_legalName" },
  { pdfFieldName: "Buyer 1 Email", convertTo: "buyer_email" },
  { pdfFieldName: "Buyer 1 Phone", convertTo: "buyer_phone" },

  { pdfFieldName: "Buyer 2 First Name", convertTo: "buyer2_firstName" },
  { pdfFieldName: "Buyer 2 Last Name", convertTo: "buyer2_lastName" },
  { pdfFieldName: "Buyer 2 Name", convertTo: "buyer2_legalName" },
  { pdfFieldName: "Buyer 2 First Name 2", convertTo: "buyer2_firstName" },
  { pdfFieldName: "Buyer 2 Last Name 2", convertTo: "buyer2_lastName" },
  { pdfFieldName: "Buyer 2 Name 2", convertTo: "buyer2_legalName" },
  { pdfFieldName: "Buyer 2 Email", convertTo: "buyer2_email" },
  { pdfFieldName: "Buyer 2 Phone", convertTo: "buyer2_phone" },

  { pdfFieldName: "Buyer 3 First Name", convertTo: "buyer3_firstName" },
  { pdfFieldName: "Buyer 3 Last Name", convertTo: "buyer3_lastName" },
  { pdfFieldName: "Buyer 3 Name", convertTo: "buyer3_legalName" },
  { pdfFieldName: "Buyer 3 First Name 2", convertTo: "buyer3_firstName" },
  { pdfFieldName: "Buyer 3 Last Name 2", convertTo: "buyer3_lastName" },
  { pdfFieldName: "Buyer 3 Name 2", convertTo: "buyer3_legalName" },
  { pdfFieldName: "Buyer 3 Email", convertTo: "buyer3_email" },
  { pdfFieldName: "Buyer 3 Phone", convertTo: "buyer3_phone" },
 
  { pdfFieldName: "Seller Broker Name", convertTo: "brokerSeller_fullname" },
  { pdfFieldName: "Seller Broker Name 2", convertTo: "brokerSeller_fullname" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Broker Phone", convertTo: "brokerSeller_phone" },
  { pdfFieldName: "Seller Broker Email", convertTo: "brokerSeller_email" },
  { pdfFieldName: "Seller Broker License", convertTo: "brokerSeller_brokerLicenseNumber" },
  { pdfFieldName: "Seller Brokerage Firm Name", convertTo: "brokerSeller_brokerageName" },
  { pdfFieldName: "Seller Brokerage Firm Name 2", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 3", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 4", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 5", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 6", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 7", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 8", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 9", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 10", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 11", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 12", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 13", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 14", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 15", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 16", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 17", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 18", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 19", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm Name 20", convertTo: "brokerSeller_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Seller Brokerage Firm License", convertTo: "brokerSeller_brokerageLicenseNumber" },
  { pdfFieldName: "Seller Brokerage Address", convertTo: "brokerSeller_addressFull" },
  { pdfFieldName: "Seller Brokerage Address Street", convertTo: "brokerSeller_addressStreetAndUnit" },
  { pdfFieldName: "Seller Brokerage Address City State Zip", convertTo: "brokerSeller_addressCityStateZipcode" },
  { pdfFieldName: "Seller CoAgent Name", convertTo: "coAgentSeller_fullname" },
   { pdfFieldName: "Seller CoAgent Name 2", convertTo: "coAgentSeller_fullname" },
  { pdfFieldName: "Seller Broker and CoAgent Names", convertTo: "brokerSeller_fullnameAndCoAgent" },

  { pdfFieldName: "Buyer Broker Name", convertTo: "brokerBuyer_fullname" },
  { pdfFieldName: "Buyer Broker Name 2", convertTo: "brokerBuyer_fullname" },
  { pdfFieldName: "Buyer Broker Phone", convertTo: "brokerBuyer_phone" },
  { pdfFieldName: "Buyer Broker Email", convertTo: "brokerBuyer_email" },
  { pdfFieldName: "Buyer Broker License", convertTo: "brokerBuyer_brokerLicenseNumber" },
  { pdfFieldName: "Buyer Brokerage Firm Name 1", convertTo: "brokerBuyer_brokerageName" },
  { pdfFieldName: "Buyer Brokerage Firm Name", convertTo: "brokerBuyer_brokerageName" },
  { pdfFieldName: "Buyer Brokerage Firm Name 2", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 3", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 4", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 5", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 6", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 7", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 8", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 9", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 10", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 11", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 12", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 13", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 14", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 15", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 16", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 17", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 18", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 19", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
  { pdfFieldName: "Buyer Brokerage Firm Name 20", convertTo: "brokerBuyer_brokerageName" },  // in case there are 2 on the form
 
  { pdfFieldName: "Buyer Brokerage Firm License", convertTo: "brokerBuyer_brokerageLicenseNumber" },
  { pdfFieldName: "Buyer Brokerage Address", convertTo: "brokerBuyer_addressFull" },
  { pdfFieldName: "Buyer Brokerage Address Street", convertTo: "brokerBuyer_addressStreetAndUnit" },
  { pdfFieldName: "Buyer Brokerage Address City State Zip", convertTo: "brokerBuyer_addressCityStateZipcode" },
  { pdfFieldName: "Buyer CoAgent Name", convertTo: "coAgentBuyer_fullname" },
  { pdfFieldName: "Buyer CoAgent Name 2", convertTo: "coAgentBuyer_fullname" },
  { pdfFieldName: "Buyer Broker and CoAgent Names", convertTo: "brokerBuyer_fullnameAndCoAgent" },

  { pdfFieldName: "Agent Name", convertTo: "meAgent_fullname" },
  { pdfFieldName: "Agent Name 2", convertTo: "meAgent_fullname" },
  { pdfFieldName: "Agent License", convertTo: "meAgent_brokerLicenseNumber" },
  { pdfFieldName: "Agent Phone", convertTo: "meAgent_phone" },
  { pdfFieldName: "Agent Email", convertTo: "meAgent_email" },
  { pdfFieldName: "Agent Address", convertTo: "meAgent_addressFull" },
  { pdfFieldName: "Agent Address Street", convertTo: "meAgent_addressStreetAndUnit" },
  { pdfFieldName: "Agent Address City State Zip", convertTo: "meAgent_addressCityStateZipcode" },
  { pdfFieldName: "Agent Address City", convertTo: "meAgent_addressCity" },
  { pdfFieldName: "Agent Address State", convertTo: "meAgent_addressState" },
  { pdfFieldName: "Agent Address Zip", convertTo: "meAgent_addressZipcode" },
  { pdfFieldName: "Agent Brokerage Firm Name", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 1", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 2", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 3", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 4", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 5", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 6", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 7", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 8", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 9", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 10", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 11", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 12", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 13", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 14", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 15", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 16", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 17", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 18", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 19", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm Name 20", convertTo: "meAgent_brokerageName" },
  { pdfFieldName: "Agent Brokerage Firm License", convertTo: "meAgent_brokerageLicenseNumber" },
  { pdfFieldName: "Agent Brokerage Manager Name", convertTo: "meAgent_brokerageManagerFullName" },

  { pdfFieldName: "Client Names Legal", convertTo: "transaction_clientFullNames" },
  { pdfFieldName: "Client Names Legal 2", convertTo: "transaction_clientFullNames" },
  { pdfFieldName: "Client Emails", convertTo: "transaction_clientAllEmails" },
  { pdfFieldName: "Client 1 Name Legal", convertTo: "transaction_client1FullName" },
    { pdfFieldName: "Client 1 Name Legal 2", convertTo: "transaction_client1FullName" },
  { pdfFieldName: "Client 1 Name Signer", convertTo: "transaction_client1SignerFullName" },
  { pdfFieldName: "Client 1 Email", convertTo: "transaction_client1Email" },
  { pdfFieldName: "Client 2 Name Legal", convertTo: "transaction_client2FullName" },
    { pdfFieldName: "Client 2 Name Legal 2", convertTo: "transaction_client2FullName" },
  { pdfFieldName: "Client 2 Name Signer", convertTo: "transaction_client2SignerFullName" },
  { pdfFieldName: "Client 2 Email", convertTo: "transaction_client2Email" },
  { pdfFieldName: "Client 3 Name Legal", convertTo: "transaction_client3FullName" },
  { pdfFieldName: "Client 3 Name Signer", convertTo: "transaction_client3SignerFullName" },
  { pdfFieldName: "Client 3 Email", convertTo: "transaction_client3Email" },

  { pdfFieldName: "Title Company Representative Name", convertTo: "titleCompany_fullname" },
  { pdfFieldName: "Title Company Name", convertTo: "titleCompany_companyName" },
  { pdfFieldName: "Title Company Name 2", convertTo: "titleCompany_companyName" },
  { pdfFieldName: "Title Company Address Full", convertTo: "titleCompany_addressFull" },
  { pdfFieldName: "Title Company Address Street", convertTo: "titleCompany_addressStreetAndUnit" },
  { pdfFieldName: "Title Company Address City State Zip", convertTo: "titleCompany_addressCityStateZip" },
  { pdfFieldName: "Title Company Address City", convertTo: "titleCompany_addressCity" },
  { pdfFieldName: "Title Company Address State", convertTo: "titleCompany_addressState" },
  { pdfFieldName: "Title Company Address Zip", convertTo: "titleCompany_addressZipcode" },
  { pdfFieldName: "Title Company Phone", convertTo: "titleCompany_phone" },
  { pdfFieldName: "Title Company Email", convertTo: "titleCompany_email" },

  { pdfFieldName: "Listing Inclusions", convertTo: "transaction_inclusions" },
  { pdfFieldName: "Listing Exclusions", convertTo: "transaction_exclusions" },
  { pdfFieldName: "Listing Year Built", convertTo: "transaction_yearBuilt" },
  // NOTES for extraction:
  // Signature Buyer Broker   // Date Signature Buyer Broker
  // Signature Buyer CoAgent  // Date Signature Buyer CoAgent
  // Signature Seller Broker  // Date Signature Seller Broker
  // Signature Seller CoAgent // Date Signature Seller CoAgent 
  // Signature Transaction Coordinator
  // Signature Manager
  
  // Prompt to ADD TO DO ITEMS
  // SPD: Checkbox HOA Property is part of an owners association
  // Checkbox Group Inclusions Solar Panels
  // CBS: Occupancy Agreements
  // CBS: Other Documents
  // CBS: Checkbox ChecklistItem Personal Property Agreement

  // CBS: Section 2:
    // Radiobutton Title Joint Tenants
    // Radiobutton Title Tenants In Common
    // Radiobutton Title Other          
    // Title Other
    //
    // Number of Remote Controls
    // Checkbox Group Inclusions Solar Panels
    // Checkbox Group Inclusions Water Softeners
    // Checkbox Group Inclusions Security Systems
    // Checkbox Group Inclusions Satellite Systems
    // Inclusions
    // Checkbox ChecklistItem Personal Property Agreement
    // Inclusions Encumbered
    // Radiobutton AssumeDebtOnEncumberedInclusions Will
    // Radiobutton AssumeDebtOnEncumberedInclusions Will Not
    // Parking
    // Storage Facilities
    // Leased Items
    // Radiobutton BuyerAssumeSellerDebtOnLeasedItems Will
    // Radiobutton BuyerAssumeSellerDebtOnLeasedItems Will Not
    // Checkbox ChecklistItem Solar Power Plan
      // Radiobutton AssumeSolarPowerPlan Will
      // Radiobutton AssumeSolarPowerPlan Will Not
    // Exclusions
    // Checkbox Group WaterRights Deeded Water Rights
      // Deeded Water Rights
      // Deeded Water Rights Deed
    // Checkbox Group WaterRights Other Rights Relating to Water
    // Checkbox Group WaterRights Well Rights
      // WaterRights Well Permit Number
    // Checkbox Group WaterRights Water Stock
      // WaterRights Water Stock Field
  // CBS: Section 3:
    // Radiobutton DeadlinesExtendedToNextBusinessDay Will
    // Radiobutton DeadlinesExtendedToNextBusinessDay Will Not
  // CBS: Section 4:
    // Amount Purchase Price
    // Amount Earnest Money
    // Amount New Loan
    // Amount Assumption Balance
    // Amount Private Financing
    // Amount Seller Financing
    // Item 7 Description
      // Amount Item 7 Debit
      // Amount Item 7 Credit
    // Item 8 Description
      // Amount Item 8 Debit
      // Amount Item 8 Credit
    // Amount Cash at Closing
    // CALCULATE Amount Purchase Price PLUS Amount Item 7 Debit PLUS Amount Item 8 Debit
    // CALCULATE Amount Earnest Money PLUS Amount New Loan PLUS Amount Assumption Balance PLUS Amount Private Financing PLUS Amount Seller Financing PLUS Amount Item 7 Credit PLUS Amount Item 8 Credit PLUS Amount Cash at Closing
    // Amount Seller Concession
    // Earnest Money Form
    // Earnest Money Holder
    //  
    // Radiobutton AvailableFunds Does not have funds
    // Checkbox Group Loan Conventional
    // Checkbox Group Loan FHA 
    // Checkbox Group Loan VA 
    // Checkbox Group Loan Bond
    // Checkbox Group Loan Other
      // Loan Other
    // Amount FHA VA Closing Costs Max
    // ASSUMPTION
        // Amount Assumption At
        // Assumption Per
        // Assumption Rate
        // Checkbox AssumptionEscrow Real Estate Taxes
        // Checkbox AssumptionEscrow Property Insurance Premium
        // Checkbox AssumptionEscrow Mortgage Insurance Premium
        // Checkbox AssumptionEscrow Other
        // AssumptionEscrow Other
        // Amount Assumption Loan Transfer Fee Max
        // Amount Assumption Loan Interest Rate Max
        // Amount Assumption New Payment Max
        // Assumption New Payment Per
        //  
        // Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will
        // Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will Not
        // Radiobutton AssumptionReleaseDelivery On or Before Loan Transfer Approval Deadline
        // Radiobutton AssumptionReleaseDelivery At Closing
        // Assumption Release of Liability Paid By
        // Amount Assumption Release of Liability Max Cost
    // Radiobutton SellerFinancingDeliversFinancingDocuments Buyer
    // Radiobutton SellerFinancingDeliversFinancingDocuments Seller
    // Seller Financing Deliver Financing Documents Number Days before Seller or Private Financing Deadline
  // CBS: Section 5:
    // Checkbox Buyer will not occupy as primary residence
  // CBS: Section 6:
    // Amount FHA Minimum Appraised Value
    // Radiobutton WhoPaysAppraisal Buyer
    // Radiobutton WhoPaysAppraisal Seller
  // CBS: Section 8:
    // Radiobutton WhoSelectsTitleCompany Seller
      // Checkbox Abstract of Title
    // Radiobutton WhoSelectsTitleCompany Buyer
    // Radiobutton TitleContainsOEC Will
    // Radiobutton TitleContainsOEC Will Not
    // Radiobutton WhoPaysOEC Buyer
    // Radiobutton WhoPaysOEC Seller
    // Radiobutton WhoPaysOEC Split
    // Radiobutton WhoPaysOEC Other
    // WhoPaysOEC Other
    // Website Metro District
    // Radiobutton WhoPaysTaxCertificate Seller
    // Radiobutton WhoPaysTaxCertificate Buyer
  // CBS: Section 9:
    // Checkbox New ILC  
    // Checkbox New Survey
      // New Survey in the form of
    // Radiobutton WhoOrdersNew_ILC_OrSurvey Seller
    // Radiobutton WhoOrdersNew_ILC_OrSurvey Buyer
    // Radiobutton WhoPaysNewILCorSurvey Seller
    // Radiobutton WhoPaysNewILCorSurvey Buyer
    // Radiobutton WhoPaysNewILCorSurvey Other
    // WhoPaysNewILCorSurvey Other  
    // Delivery ILC
  // CBS: Section 10:
    // Occupancy Agreements
    // Other Documents
    // Conditional On Sale Of Property
    // Radiobutton AcknowledgeReceiptOfSPD Does
    // Radiobutton AcknowledgeReceiptOfSPD Does Not
    // Checkbox Well There is no well
    // Radiobutton AcknowledgeReceiptWellPermit Does
    // Radiobutton AcknowledgeReceiptWellPermit Does Not
  // CBS: Section 12:
    // Radiobutton ClosingInstructionsExecutedWithContract Are
    // Radiobutton ClosingInstructionsExecutedWithContract Are Not
    // Closing Designated By 

    // Checkbox ChecklistItem Due Diligence  Environmental order or provide Phase I Environmental Site Assessment

  // CBS: Section 13:
    // Radiobutton DeedType Special Warranty Deed
    // Radiobutton DeedType General Warranty Deed
    // Radiobutton DeedType Bargain And Sale Deed
    // Radiobutton DeedType Quit Claim Deed
    // Radiobutton DeedType Personal Representatives Deed
    // DeedType Deed Other
    // Deed Other
  // CBS: Section 15:
    // Radiobutton ClosingServicesFee Buyer
    // Radiobutton ClosingServicesFee Seller
    // Radiobutton ClosingServicesFee Split
    // Checkbox ClosingServicesFee Other  // ClosingServicesFee Other
    // Radiobutton RecordChangeFee Buyer
    // Radiobutton RecordChangeFee Seller
    // Radiobutton RecordChangeFee Half
    // Radiobutton RecordChangeFee NA
    // Radiobutton ReservesOrWorkingCapital Buyer
    // Radiobutton ReservesOrWorkingCapital Seller
    // Radiobutton ReservesOrWorkingCapital Half
    // Radiobutton ReservesOrWorkingCapital NA
    // Radiobutton OtherFees Buyer
    // Radiobutton OtherFees Seller 
    // Radiobutton OtherFees Half
    // Radiobutton OtherFees NA
    // Radiobutton LocalTransferTax Buyer
    // Radiobutton LocalTransferTax Seller
    // Radiobutton LocalTransferTax Half
    // Radiobutton LocalTransferTax NA
    // Radiobutton SalesAndUseTax Buyer
    // Radiobutton SalesAndUseTax Seller
    // Radiobutton SalesAndUseTax Half
    // Radiobutton SalesAndUseTax NA
    // Radiobutton PrivateTransferFee Buyer
    // Radiobutton PrivateTransferFee Seller
    // Radiobutton PrivateTransferFee Half
    // Radiobutton PrivateTransferFee NA
    // Amount Water Transfer Fee
      // Checkbox Water DistrictMunicipality
      // Checkbox Augmentation Membership
      // Checkbox Small Domestic Water Company
      // Checkbox Water Stock
      // Checkbox Water Transfer Fee Other
      // Water Transfer Fee Other
    // Radiobutton WaterTransferFee Buyer
    // Radiobutton WaterTransferFee Seller
    // Radiobutton WaterTransferFee Half
    // Radiobutton WaterTransferFee NA
    // Radiobutton UtilityTransferFee Buyer
    // Radiobutton UtilityTransferFee Seller
    // Radiobutton UtilityTransferFee Half
    // Radiobutton UtilityTransferFee NA
    // Checkbox IS a foreign person
  // CBS: Section 16:
    // Radiobutton Taxes Taxes for the Calendar Year Immediately Preceding Closing
    // Radiobutton Taxes Most Recent Mill Levy and Most Recent Assessed or Actual Valuation per the county assessor
    // Radiobutton Taxes Other
    // Taxes Other
    // Radiobutton Rents Actually Received
    // Radiobutton Rents Accrued
    // Other Prorations
    // Radiobutton AssociationAssessmentsObligation Buyer
    // Radiobutton AssociationAssessmentsObligation Seller
    // Special Assessments
  // CBS: Section 17:
    // Amount Possession Per Day
  // CBS: Section 20: 
    // Checkbox Specific Performance
  // CBS: Section 26:
    // Electronic Notice
  // CBS: Section 29:
      // Checkbox PaysBuyerBrokerage Seller             // can be multi-select
      // Checkbox PaysBuyerBrokerage Buyer              // can be multi-select
      // Checkbox PaysBuyerBrokerage Sellers Brokerage  // can be multi-select
      // Percent Seller Pays Buyer Brokerage
      // Amount Seller Pays Buyer Brokerage
      // Percent Buyer Pays Buyer Brokerage
      // Amount Buyer Pays Buyer Brokerage
      // Percent Sellers Brokerage Pays Buyer Brokerage
      // Amount Sellers Brokerage Pays Buyer Brokerage
  // CBS: Section 30:
    // Additional Provisions
    // Additional Provisions 2
  // CBS: Section 31:
    // Documents Part of Contract
    // Documents Not Part of Contract
  // CBS: Signatures - see above
  // CBS: Broker Section - see above and below
    // Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does
    // Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does Not

    // CBS: Radiobutton BuyerBrokerRelationship Buyers Agent
    // CBS: Radiobutton BuyerBrokerRelationship Transaction Broker
    // CBS: Radiobutton BuyerBrokerRelationship Customer

    // Broker Seller Section: - see above and below
    // Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does
    // Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does Not
    // CBS: Radiobutton SellerBrokerRelationship Sellers Agent
    // CBS: Radiobutton SellerBrokerRelationship Transaction Broker
    // CBS: Radiobutton SellerBrokerRelationship Customer
      // Checkbox SellerBrokerageFirmPaidBy Seller    // can be multi-select
      // Checkbox SellerBrokerageFirmPaidBy Buyer     // can be multi-select
      // Checkbox SellerBrokerageFirmPaidBy Other     // can be multi-select
      // SellerBrokerageFirmPaidBy Other
    

 
  // Radiobutton [buttonGroupName] 

  // AGENCY - Seller
  // Radiobutton SellerBrokerRelationship Sellers Agent
  // Radiobutton SellerBrokerRelationship Transaction Broker
  // Radiobutton BrokerageFirmSize Multi Person
  // Radiobutton BrokerageFirmSize One Person
  // Checkbox AffordableHousing Is
  // Checkbox LeaseAgreement Is
  // Date Listing Begins
  // Date Listing Ends
  // DateText Listing Ends
  // Radiobutton DeadlinesExtendedToNextBusinessDay Will
  // Radiobutton DeadlinesExtendedToNextBusinessDay Will Not
  // Checkbox Seller Agency Only
  // Radiobutton DisclosureOfOffers Does Consent
  // Radiobutton DisclosureOfOffers Does Not Consent
  // Percent Sale Compensation
  // Amount Sale Compensation
  // Percent Buyer Broker Compensation
  // Amoount Buyer Broker Compensation
  // Percent Lease Compensation
  // Amount Lease Compensation
  // Lease Compensation Payable As Follows
  // Percent Lease Compensation To Tenant Brokerage Firm
  // Amount Lease Compensation To Tenant Brokerage Firm
  // Lease Other Compensation
  // Holdover Period Days
  // Radiobutton HoldoverSellerOwesCompensation Will
  // Radiobutton HoldoverSellerOwesCompensation Will Not
  // Radiobutton SubmittedToMLS Will
  // Radiobutton SubmittedToMLS Will Not
  // Radiobutton SubmittedToPropertyExchanges Will
  // Radiobutton SubmittedToPropertyExchanges Will Not
  // Marketing Except
  // Radiobutton PropertyAddressOnInternet Will
  // Radiobutton PropertyAddressOnInternet Will Not
  // Radiobutton PropertyListingOnInternet Will
  // Radiobutton PropertyListingOnInternet Will Not
  // Checkbox PropertyAccess Electronic Lock Box
  // Checkbox PropertyAccess Manual Lock Box
  // Checkbox PropertyAccess Other
  // PropertyAccess Other
  // PropertyAccess Other Instructions 1
  // PropertyAccess Other Instructions 2
  // Checkbox AccessToProperty Actively Licensed Real Estate Brokers
  // Checkbox AccessToProperty Unlicensed Broker Assistants
  // Checkbox AccessToProperty Licensed Appraisers
  // Checkbox AccessToProperty Unlicensed Inspectors
  // Checkbox AccessToProperty Other
  // AccessToProperty Other1
  // AccessToProperty Other2
  // Marketing
  // Videos Pictures Except
  // Radiobutton NoExistingListingAgreement Is
  // Radiobutton NoExistingListingAgreement Is Not
  // Radiobutton ReceivedListSubmittedProperties Has
  // Radiobutton ReceivedListSubmittedProperties Has Not
  // Amount Listing Price
  // Checkbox Group Loan Cash
  // Checkbox Group Loan Conventional
  // Checkbox Group Loan FHA 
  // Checkbox Group Loan VA 
  // Checkbox Group Loan Bond
  // Checkbox Group Loan Other
  // Loan Other
  // Loan Discount Points
  // Amount FHA Closing Costs
  // FHA Not Allowed To Pay
  // Amount Earnest Money Minimum
  // Earnest Money Form
  // Radiobutton SellerProceeds Cashiers Check
  // Radiobutton SellerProceeds Wire Transfer
  // Radiobutton SellerProceeds Closing Companys Trust Account
    // Checkbox Group Inclusions None
    // Checkbox Group Inclusions Solar Panels
    // Checkbox Group Inclusions Water Softeners
    // Checkbox Group Inclusions Security Systems
    // Checkbox Group Inclusions Satellite Systems
    // Inclusions
    // Encumbered Inclusions
    // Leased Items
    // Exclusions
    // Trade Fixtures Included
    // Trade Fixtures Included Encumbrance Exception
    // Parking
    // Storage Facilities
    // Checkbox Group WaterRights Deeded Water Rights
      // WaterRights Deeded Water Rights
      // WaterRights Deeded Water Rights Deed
    // Checkbox Group WaterRights Other Rights Relating to Water
    //  WaterRights OtherRights Relating to Water
    // Checkbox Group WaterRights Well Rights
      // WaterRights Well Permit Number
    // Checkbox Group WaterRights Water Stock
      // WaterRights Water Stock Field
      // Growing Crops
      // Radiobutton DeedType Special Warranty Deed
    // Radiobutton DeedType General Warranty Deed
    // Radiobutton DeedType Bargain And Sale Deed
    // Radiobutton DeedType Quit Claim Deed
    // Radiobutton DeedType Personal Representatives Deed
    // Radiobutton DeedType Deed Other
    // DeedType Deed Other
    // Monetary Encumbrances
    // Tenancies
    // RadioButton LocatedInOwersAssociation Is
    // RadioButton LocatedInOwersAssociation Is Not
    // Amount Association Assessment
    // Frequency Association Assessment
    // Special Assessments
    // Possession Details
    // Radiobutton SellerProvidesSPD Agrees
    // Radiobutton SellerProvidesSPD Does Not Agree
    // Radiobutton ForfeitureOfPayments Paid To Seller
    // Radiobutton ForfeitureOfPayments Split Seller And Brokerage Firm
    // Radiobutton ForfeitureOfPayments Other
    // ForfeitureOfPayments Other
    // Additional Provisions
    // Additional Provisions 2
    // Attachments
    // Electronic Notice


    // Closing Instructions
    // Title Closing Fee

    // note to self: for other textfield, include everything after [Radiobutton|Checkbox]
    // note to self: for radiobuttons, if Radiobutton GroupName, then textfields start with GroupName
    // note to self: for checkboxes, if Checkbox Group GroupName, then textfields start with GroupName
];